import {DOMAttributes} from 'react'
import {Flexbox, FlexboxProps} from '@/components/ui/flexbox/FlexBox'
import {SupportedHTMLElements} from 'styled-components'
import {StyledAuthForm, StyledAuthSubtitle, StyledAuthTitle, StyledAuthWrapper} from '@/components/ui/auth-atoms/style'
import Logo from '@assets/images/logo.svg'

export const AuthWrapper = (props: DOMAttributes<HTMLElement>) => <StyledAuthWrapper {...props} />
AuthWrapper.displayName = 'AuthWrapper'

export const AuthForm = (props: Omit<FlexboxProps<SupportedHTMLElements>, 'render' | 'direction'>) => (
    <StyledAuthForm {...props} render="form" direction="column" />
)
AuthForm.displayName = 'AuthForm'

export const AuthTitle = (props: DOMAttributes<HTMLElement>) => <StyledAuthTitle {...props} />
AuthTitle.displayName = 'AuthTitle'

export const AuthSubTitle = (props: DOMAttributes<HTMLElement>) => <StyledAuthSubtitle {...props} />
AuthSubTitle.displayName = 'AuthSubTitle'

export const AuthHeading = ({title, subtitle, showLogo}: {title: string; subtitle: string; showLogo?: boolean}) => {
    return (
        <Flexbox fullWidth direction="column" gap={6} align="center">
            {showLogo && <img src={Logo} alt={'logo'} width={48} />}
            <Flexbox direction="column" gap={2} align="center">
                <AuthTitle>{title}</AuthTitle>
                <AuthSubTitle>{subtitle}</AuthSubTitle>
            </Flexbox>
        </Flexbox>
    )
}
AuthHeading.displayName = 'AuthHeading'
